import moment from 'moment'

moment.locale('pt-br')

export function toNumber(value) {
  if (value === null || value === undefined || value === '') {
    return 0
  }

  const normalized = Number(String(value).replace(',', '.'))
  return Number.isFinite(normalized) ? normalized : 0
}

export function getMovementProductId(item) {
  return item.id_produto || (item.produto && item.produto.id_produto) || null
}

export function getMovementProductName(item) {
  return item.nome || (item.produto && item.produto.nome) || 'Produto sem nome'
}

export function getMovementTimestamp(item) {
  if (!item || !item.data) {
    return 0
  }

  const parsed = moment(item.data)
  return parsed.isValid() ? parsed.valueOf() : 0
}

export function formatMovementDate(value) {
  if (!value) {
    return '--'
  }

  const parsed = moment(value)
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : value
}

export function buildStockSummary(movements = [], products = []) {
  const grouped = new Map()

  movements.forEach((movement) => {
    const productId = getMovementProductId(movement)
    const fallbackKey = getMovementProductName(movement)
    const key = productId || fallbackKey

    if (!grouped.has(key)) {
      grouped.set(key, {
        id_produto: productId,
        nome: getMovementProductName(movement),
        disponivel: toNumber(movement.disponivel),
        minimo: toNumber(movement.minimo),
        maximo: toNumber(movement.maximo),
        quantidade_embalagens: toNumber(movement.quantidade),
        ultima_movimentacao: movement.data,
        tipo_movimento: movement.tipo_movimento || '',
        source: movement,
      })
      return
    }

    const current = grouped.get(key)
    const currentTime = getMovementTimestamp(current.source)
    const nextTime = getMovementTimestamp(movement)

    if (nextTime >= currentTime) {
      grouped.set(key, {
        id_produto: productId,
        nome: getMovementProductName(movement),
        disponivel: toNumber(movement.disponivel),
        minimo: toNumber(movement.minimo),
        maximo: toNumber(movement.maximo),
        quantidade_embalagens: toNumber(movement.quantidade),
        ultima_movimentacao: movement.data,
        tipo_movimento: movement.tipo_movimento || '',
        source: movement,
      })
    }
  })

  products.forEach((product) => {
    const key = product.id_produto || product.nome
    if (!grouped.has(key)) {
      grouped.set(key, {
        id_produto: product.id_produto,
        nome: product.nome,
        disponivel: toNumber(product.disponivel),
        minimo: toNumber(product.minimo),
        maximo: toNumber(product.maximo),
        quantidade_embalagens: 0,
        ultima_movimentacao: null,
        tipo_movimento: '',
        source: product,
      })
    }
  })

  return Array.from(grouped.values())
    .map((item) => {
      const needsRestock = item.minimo > 0 && item.disponivel < item.minimo
      const isOutOfStock = item.disponivel <= 0
      const isAboveMax = item.maximo > 0 && item.disponivel > item.maximo
      const hasLimitConfig = item.minimo > 0 || item.maximo > 0
      const suggestedQuantity =
        item.maximo > 0
          ? Math.max(item.maximo - item.disponivel, 0)
          : Math.max(item.minimo - item.disponivel, 0)

      let status = 'ok'
      let statusLabel = 'Saudavel'

      if (!hasLimitConfig) {
        status = 'unconfigured'
        statusLabel = 'Sem parametrizacao'
      } else if (isOutOfStock) {
        status = 'empty'
        statusLabel = 'Sem saldo'
      } else if (needsRestock) {
        status = 'low'
        statusLabel = 'Abaixo do minimo'
      } else if (isAboveMax) {
        status = 'high'
        statusLabel = 'Acima do maximo'
      }

      return {
        ...item,
        suggestedQuantity,
        needsRestock,
        isOutOfStock,
        isAboveMax,
        hasLimitConfig,
        status,
        statusLabel,
      }
    })
    .sort((a, b) => a.nome.localeCompare(b.nome))
}

export function summarizeStock(summary = [], movements = []) {
  return {
    totalProdutos: summary.length,
    abaixoMinimo: summary.filter((item) => item.status === 'low').length,
    semSaldo: summary.filter((item) => item.status === 'empty').length,
    acimaMaximo: summary.filter((item) => item.status === 'high').length,
    semParametros: summary.filter((item) => item.status === 'unconfigured')
      .length,
    totalMovimentacoes: movements.length,
  }
}
